import {
	PasswordInput,
	DateTimeInput,
	AutocompleteInput,
	SimpleForm,
	TextInput,
	required,
	useGetIdentity,
	useRecordContext,
	ReferenceArrayInput
} from 'react-admin';

import { RoleChoices } from 'skylar-data/src/Roles';

// Disabled if current user is viewing themselves. Prevents priv escalation and lockout.
const RoleSelector = () => {
	const record = useRecordContext();
	const { data } = useGetIdentity();
	const disabled = record?.id === data.id || ( !data.role.includes( 'superadmin' ) && record?.role.includes( 'superadmin' ) );
	const choices = data.role.includes( 'superadmin' ) || disabled ? RoleChoices : RoleChoices.filter( (r) => r.id !== 'superadmin' );
	return <AutocompleteInput source="role" disabled={disabled} choices={choices} />
}

export const FormFields = (
	<SimpleForm>
		<TextInput source="email" validate={required()} />
		<PasswordInput source="new_password" />
		<TextInput source="name" validate={required()} />
		<ReferenceArrayInput reference="groups" source="group_ids" label="Groups" />
		<RoleSelector />
		<DateTimeInput source="last_login" disabled fullWidth={false} />
	</SimpleForm>

);